import { IOfferCallout } from "@/api_framework/api_modals/Bookings";
import { Sparkles } from "lucide-react";

// The backend sends the app's (Flutter) colours: #AARRGGBB, which CSS would read as #RRGGBBAA.
const toCssColor = (color: string) => (/^#[0-9a-f]{8}$/i.test(color) ? `#${color.slice(3)}${color.slice(1, 3)}` : color);

const ALIGNMENT_POSITION: Record<string, string> = {
  center_left: "left center",
  center_right: "right center",
  top_left: "left top",
  top_center: "center top",
  top_right: "right top",
  bottom_left: "left bottom",
  bottom_center: "center bottom",
  bottom_right: "right bottom",
  center: "center",
};

const toTextGradient = (callout: IOfferCallout) => {
  const colors = (callout.fg_gradient_colors ?? []).map(toCssColor);
  if (colors.length === 0) return undefined;
  const stops = colors.map((color, index) =>
    callout.fg_gradient_stops?.[index] != null ? `${color} ${callout.fg_gradient_stops[index] * 100}%` : color,
  );
  const position = ALIGNMENT_POSITION[callout.fg_gradient_begin_alignment ?? ""] ?? "left center";
  return callout.fg_gradient_type === "radial"
    ? `radial-gradient(circle at ${position}, ${stops.join(", ")})`
    : `linear-gradient(to right, ${stops.join(", ")})`;
};

const SIZE_CLASSES = {
  default: { icon: "h-4 w-4", text: "text-[12px] leading-4", sparkle: 10 },
  medium: { icon: "h-5 w-5", text: "text-[14px] leading-5", sparkle: 12 },
  large: { icon: "h-6 w-6", text: "text-[18px] leading-6", sparkle: 14 },
};

// Gift chip the backend sends on a gifted line (e.g. "Free Spa Bath"), drawn as the app does: tag icon, gradient text.
const OfferCalloutBadge: React.FC<{ callout: IOfferCallout; size?: keyof typeof SIZE_CLASSES }> = ({
  callout,
  size = "default",
}) => {
  const textGradient = toTextGradient(callout);
  const sparkleColor = toCssColor(callout.fg_gradient_colors?.[0] ?? "#7A55FF");
  const sizeClasses = SIZE_CLASSES[size];

  return (
    <span className="inline-flex shrink-0 items-center gap-1 whitespace-nowrap">
      {callout.icon && <img src={callout.icon} alt="" className={sizeClasses.icon} />}
      <span
        className={`${sizeClasses.text} font-semibold`}
        style={
          textGradient
            ? { backgroundImage: textGradient, WebkitBackgroundClip: "text", backgroundClip: "text", color: "transparent" }
            : { color: sparkleColor }
        }
      >
        {callout.txt_sft}
      </span>
      <Sparkles size={sizeClasses.sparkle} className="-ml-0.5 self-start" color={sparkleColor} fill={sparkleColor} />
    </span>
  );
};

export default OfferCalloutBadge;
